import useMain from 'hooks/useMain';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import {
  rFetchCategories,
  rFetchCompanies,
  rFetchConcretes,
  rFetchFloors,
  rFetchLocations,
  rFetchRegions,
  rFetchSteps,
  setState
} from 'store/reducers/comModule';
import { mapListToOptions, OptionUtils } from 'utils/common';
import { BC_TYPE } from '../constant';

export const useFetchData = ({ forFilter }) => {
  const { t, useLocation, dispatch, useSelector } = useMain();
  const location = useLocation();

  const currentBctype = useSelector((state) => state.comModule.bctype);

  const selectedRegion = useSelector((state) => state.comModule.selectedRegion);
  const selectedFloor = useSelector((state) => state.comModule.selectedFloor);
  const selectedData = useSelector((state) => state.comModule.selectedData);

  const steps = useSelector((state) => state.comModule.steps);

  useEffect(() => {
    const sameType = steps.findIndex(({ Bctype }) => Bctype === currentBctype);

    if (sameType < 0) {
      dispatch(rFetchSteps());
    }
  }, [currentBctype]);

  useEffect(() => {
    dispatch(rFetchCategories());
  }, [currentBctype]);

  useEffect(() => {
    dispatch(rFetchConcretes());
  }, []);

  useEffect(() => {
    dispatch(rFetchCompanies('RSCompany'));
  }, []);

  useEffect(() => {
    dispatch(rFetchCompanies('HingeSupplier'));
  }, []);

  useEffect(() => {
    if (forFilter) {
      dispatch(rFetchLocations());
    }
  }, [forFilter]);

  useEffect(() => {
    if (!forFilter) {
      dispatch(rFetchRegions());
    }
  }, [forFilter]);

  useEffect(() => {
    if (!forFilter && selectedRegion) {
      dispatch(
        rFetchFloors({
          region: selectedRegion
        })
      );
    }
  }, [forFilter, selectedRegion]);

  useEffect(() => {
    if (!forFilter && selectedFloor && selectedRegion) {
      dispatch(
        rFetchLocations({
          region: selectedRegion,
          floor: selectedFloor
        })
      );
    }
  }, [forFilter, selectedFloor, selectedRegion]);

  const setSelectedFloor = (val) => {
    dispatch(setState(['selectedFloor', val]));
  };
  const setSelectedRegion = (val) => {
    dispatch(setState(['selectedRegion', val]));
  };

  const setSavedFilterData = (val) => {
    dispatch(setState(['savedFilterData', val]));
  };

  useEffect(() => {
    const newBctype = Object.values(BC_TYPE).find((type) => {
      return location.pathname.match(type.toLowerCase());
    });
    if (newBctype !== currentBctype) {
      dispatch(setState(['selectedData', []]));

      setSavedFilterData({});
      setSelectedFloor('');
      setSelectedRegion('');
      dispatch(setState(['bctype', newBctype]));
    }
    // if (!location.pathname.includes('batch')) {
    //   dispatch(setState(['selectedData', []]));
    // }
  }, [location.pathname]);
};

export const useData = ({ forFilter, reset }) => {
  const { t, useNavigate, useLocation, dispatch, useSelector, project, upperCaseLang } = useMain();
  const location = useLocation();
  const isLoading = useSelector((s) => s.comModule.isLoading);
  const setLoading = (loadingState) => dispatch(setState(['isLoading', loadingState]));
  const currentBctype = useSelector((state) => state.comModule.bctype);
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const savedFilterData = useSelector((state) => state.comModule.savedFilterData);
  const categories = useSelector((state) => state.comModule.categories);
  const subCategories = useSelector((state) => state.comModule.subCategories);
  const regions = useSelector((state) => state.comModule.regions);
  const floors = useSelector((state) => state.comModule.floors);
  const locations = useSelector((state) => state.comModule.locations);
  const selectedRegion = useSelector((state) => state.comModule.selectedRegion);
  const selectedFloor = useSelector((state) => state.comModule.selectedFloor);
  const selectedRoom = useSelector((state) => state.comModule.selectedRoom);
  const rsCompany = useSelector((state) => state.comModule.rscompany);
  const suppliers = useSelector((state) => state.comModule.hingesupplier);
  const steps = useSelector((state) => state.comModule.steps);
  const targetTypeSteps = useMemo(() => steps.filter(({ Bctype }) => Bctype === currentBctype), [steps, currentBctype]);
  const concretes = useSelector((state) => state.comModule.concretes);
  const rsCompanyOptions = mapListToOptions(rsCompany, `Name${upperCaseLang}`, 'Id');
  const supplierOptions = mapListToOptions(suppliers, `Name${upperCaseLang}`, 'Id');
  const concreteOptions = mapListToOptions(concretes, 'Grade', 'Grade');
  const categoryOptions = OptionUtils.localizeCategoryOptions(categories, upperCaseLang);
  const subCategoryOptions = OptionUtils.localizeCategoryOptions(subCategories, upperCaseLang);
  const bcTypeOptions = OptionUtils.localizeBctypeOptions(bcTypes, upperCaseLang);
  const blockOptions = forFilter
    ? _.uniqBy(mapListToOptions(locations, 'Region', 'Region'), 'value')
    : OptionUtils.mapRegionFloorOptions(regions);
  const floorOptions = forFilter
    ? _.uniqBy(mapListToOptions(locations, 'Floor', 'Floor'), 'label')
    : OptionUtils.mapRegionFloorOptions(floors);
  const unitOptions = forFilter
    ? _.uniqBy(mapListToOptions(locations, 'Room', 'RoomId'), 'label')
    : OptionUtils.mapRoomOptionsFromLocations(locations);

  const setSelectedFloor = (val) => {
    if (val) {
      dispatch(setState(['selectedFloor', val]));
    }
  };
  const setSelectedRegion = (val) => {
    if (val) {
      dispatch(setState(['selectedRegion', val]));
    }
  };
  const setSelectedRoom = (val) => {
    if (val) {
      dispatch(setState(['selectedRoom', val]));
    }
  };

  const setSavedFilterData = (val) => {
    dispatch(setState(['savedFilterData', val]));
  };

  // useEffect(() => {
  //   if (reset) {
  //     const newBctype = Object.values(BC_TYPE).find((type) => {
  //       return location.pathname.match(type.toLowerCase());
  //     });
  //     if (newBctype !== currentBctype) {
  //       dispatch(setState(['selectedData', []]));

  //       setSavedFilterData({});
  //       setSelectedFloor('');
  //       setSelectedRegion('');
  //       dispatch(setState(['bctype', newBctype]));
  //     }
  //     if (!location.pathname.includes('batch')) {
  //       dispatch(setState(['selectedData', []]));
  //     }
  //   }
  // }, [location.pathname, reset]);

  return {
    savedFilterData,
    supplierOptions,
    categoryOptions,
    rsCompanyOptions,
    subCategoryOptions,
    bcTypeOptions,
    blockOptions,
    floorOptions,
    unitOptions,
    setSelectedFloor,
    steps,
    targetTypeSteps,
    setSelectedRegion,
    setSelectedRoom,
    selectedRoom,
    selectedRegion,
    selectedFloor,
    currentBctype,
    isLoading,
    setLoading,
    concreteOptions,
    setSavedFilterData
  };
};
